import React from "react";
import { useDemoStore } from "../../store/demoStore";
interface LogoProps {
  size?: string;
}

const Logo: React.FC<LogoProps> = ({ size = "w-8 h-8" }) => {
  const brand = useDemoStore((state) => state.brand);

  return (
    <div className="flex items-center">
      <img
        src={brand.logo}
        alt="Logo"
        className={`${size} object-contain rounded-md`}
      />
    </div>
  );
};

export default Logo;
